import { WorkTitlesAutoCompleteResponse } from "../../features/customer/types/queries";
import { Skill, WorkTitle } from "../../features/orders/orderAPI";
import { LocalizedSkill } from "../../features/talentProfile/LocalizedGroups";
import { WorkTitleOption } from "../../hooks/useWorkTitleAutocomplete";

export const toSortedWorkTitleOptions = (
  payload: Array<WorkTitle | WorkTitlesAutoCompleteResponse>,
  fieldOfWorkNames: { [id: string]: string },
  groupByFieldOfWork: boolean,
): WorkTitleOption[] => {
  const withFieldOfWork = payload.map((workTitle) => ({
    id: workTitle.id,
    name: workTitle.name,
    fieldOfWork:
      (workTitle.fieldOfWorkId && fieldOfWorkNames[workTitle.fieldOfWorkId]) ||
      workTitle.fieldOfWorkId ||
      "",
  }));

  return groupByFieldOfWork
    ? withFieldOfWork
        .sort((a, b) => a.name.localeCompare(b.name, "fi"))
        .sort((a, b) => a.fieldOfWork.localeCompare(b.fieldOfWork, "fi"))
    : withFieldOfWork.sort((a, b) => a.name.localeCompare(b.name, "fi"));
};

export const toSortedLocalizedSkills = (
  skills: Skill[],
  localizedSkillIds: { [id: string]: string },
): LocalizedSkill[] =>
  skills
    .map((skill: Skill) => ({
      ...skill,
      name: localizedSkillIds[skill.id] || skill.id,
    }))
    .sort((a: LocalizedSkill, b: LocalizedSkill) =>
      a.name.localeCompare(b.name),
    )
    .sort((a: LocalizedSkill, b: LocalizedSkill) =>
      a.fieldOfWorkId.localeCompare(b.fieldOfWorkId),
    );
